import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/Alphadots.css';

const Alphadots = () => {
  return (
    <>
      <Helmet>
        <title>Alphadots Game - Interactive Market Predictions | Redbox Global</title>
        <meta name="description" content="Play Alphadots, Redbox Global's interactive prediction game. Test your market instincts, compete with other players, and win prizes by predicting stock movements and business outcomes." />
        <meta name="keywords" content="market game, prediction game, stock market game, trading game, investment game, alphadots, market predictions, interactive game, business game" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/alphadots" />
        <meta property="og:title" content="Alphadots Game - Interactive Market Predictions | Redbox Global" />
        <meta property="og:description" content="Test your market instincts with Alphadots. Predict stock movements and compete for prizes." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/alphadots" />
        <meta name="twitter:title" content="Alphadots Game - Interactive Market Predictions | Redbox Global" />
        <meta name="twitter:description" content="Test your market instincts with Alphadots. Predict stock movements and compete for prizes." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/alphadots" />
      </Helmet>
      
      <div className="page-container">
        <div className="page-header">
          <h1>Alphadots</h1>
          <p className="page-subtitle">Predict market moves, compete with players worldwide, and win prizes</p>
        </div>
        
        <div className="page-content">
          <a href="/article/alphadots-weekly-challenge" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="featured-article">
              <div className="featured-image">
                <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&h=600&fit=crop" alt="Alphadots game" />
              </div>
              <div className="featured-content">
                
                <h2>This Week's Challenge: Tech Earnings Edition</h2>
                <p>Major tech companies are reporting earnings this week. Will Apple beat estimates? How will Tesla's delivery numbers impact the stock? Make your predictions on 10 key questions and compete against 50,000+ players worldwide. Top performers win prizes including premium subscriptions and exclusive market insights. Play daily and climb the leaderboard!</p>
                <span className="article-meta">New Challenges Daily • Free to Play • Win Prizes</span>
              </div>
            </div>
          </a>

          <div className="content-grid">
            <a href="/article/alphadots-leaderboard" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1579621970588-a35d0e7ab9b6?w=600&h=400&fit=crop" alt="Leaderboard" />
                </div>
                <div className="article-content">
                  <h2>Monthly Leaderboard & Prizes</h2>
                  <p>Check the rankings and see how you stack up against top market predictors worldwide.</p>
                  <span className="article-meta">Updated Daily</span>
                </div>
              </article>
            </a>

            <a href="/article/alphadots-tutorial" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=600&h=400&fit=crop" alt="Tutorial" />
                </div>
                <div className="article-content">
                  
                  <h2>How to Play Alphadots: Complete Guide</h2>
                  <p>Learn the rules, strategies, and tips to become a top market predictor.</p>
                  <span className="article-meta">5 min read</span>
                </div>
              </article>
            </a>

            <a href="/article/alphadots-success-stories" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1553729459-efe14ef6055d?w=600&h=400&fit=crop" alt="Success stories" />
                </div>
                <div className="article-content">
                
                  <h2>Top Players Share Their Winning Strategies</h2>
                  <p>Learn from the best: Interviews with Alphadots champions and their approach to predictions.</p>
                  <span className="article-meta">8 min read</span>
                </div>
              </article>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Alphadots;
